module.exports = __webpack_public_path__ + "img/564.52200ee0.jpg";